import { useCallback } from 'react'
import { UserDocuments } from 'types/documents'
import { useApiRequest } from './useApiRequest'
import pLimit from 'p-limit'
import { documentsApi } from 'api/documents'

const REQUEST_LIMIT = 2

export const useUploadDocuments = () => {
  const uploadDocumentsRequest = useApiRequest(
    (documents) => documentsApi.uploadDocuments(documents),
    undefined,
    false,
    undefined,
    false
  )

  const uploadDocuments = useCallback(
    async (selectedFiles: UserDocuments, companyId: string) => {
      const data = Object.entries(selectedFiles).reduce(
        (acc, [key, value]) => {
          value.forEach((file, index) =>
            acc.push({
              [key]: file,
              companyId: String(companyId),
              isFinished: index === value.length - 1,
            })
          )
          return acc
        },
        [] as Array<
          { [key in keyof UserDocuments]?: File } & {
            companyId: string
            isFinished: boolean
          }
        >
      )

      const limit = pLimit(REQUEST_LIMIT)

      const response = await Promise.all(
        data.map((item) => limit(() => uploadDocumentsRequest.apiRequest(item)))
      )
      return response
    },
    []
  )

  return { uploadDocuments, loading: uploadDocumentsRequest.loading }
}
